import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Button, Typography } from 'foundations-library/components'
import { TypographyType } from 'foundations-library/types'
import EditButton from './EditButton'

const jss = () => ({
    titleContainer: {
        marginBottom: 40,
        display: 'flex',
        justifyContent: 'space-between'
    },
    buttonsContainer: {
        display: 'flex',
        gap: 10
    }
})

type PropsType = {
    status?: string
    mode?: 'preview' | 'edit'
    onClickEdit?: () => unknown
    onClickSubmitPaymentFailed?: () => unknown
} & TypographyType

const useStyles = makeStyles(jss)

/**
 *
 */
const StepTitle = ({
    status,
    mode,
    onClickEdit,
    onClickSubmitPaymentFailed,
    'data-testid': dataTestId = 'step-title',
    ...props
}: PropsType): JSX.Element => {
    const styles = useStyles()
    return <div className={styles.titleContainer} data-testid={`${dataTestId}-container`}>
        <Typography variant='h5' {...props} data-testid={dataTestId}/>
        <div className={styles.buttonsContainer} data-testid={`${dataTestId}-buttons`}>
            {
                mode === 'preview' &&
                status &&
                <EditButton status={status} onClick={onClickEdit} data-testid={`${dataTestId}-edit-button`}/>
            }
            {
                mode === 'preview' && status === 'payment-failed'
                    ? <Button onClick={onClickSubmitPaymentFailed} data-testid={`${dataTestId}-submit-button`}>
                        Submit
                    </Button>
                    : <></>
            }
        </div>
    </div>
}

export default StepTitle
